import { IBaseModel } from '../../shared/interfaces/IBaseModel';
import { IPagination } from '../../shared/interfaces/IPagination';
import { ITruckBrand } from '../../shared/interfaces/ITruck';
import { requests } from '../../utils/api/api.service';
import { TRUCK_URL } from '../../utils/api/endpoints';

export const AdminTruckBrandService = {
  getAll: (pagination: IPagination): Promise<IBaseModel<ITruckBrand[]>> =>
    requests.get(`${TRUCK_URL}/brand`, pagination),
  create: (data: ITruckBrand): Promise<ITruckBrand> =>
    requests.post(`${TRUCK_URL}/brand`, data),
  update: (data: ITruckBrand): Promise<ITruckBrand> =>
    requests.put(`${TRUCK_URL}/brand/${data?.id}`, data),
  delete: (id: number): Promise<ITruckBrand> =>
    requests.delete(`${TRUCK_URL}/brand/${id}`),
};
